<template>
  <v-container class="px-12 pt-12" fluid>
    <v-row class="px-12 pt-8">
      <v-col cols="12" class="d-flex px-6">
        <section class="mr-12 pr-12">
          <v-img width="390" height="342" :src="require('@/assets/communicate-by-channel.svg')"></v-img>
        </section>

        <section class="ml-12 pl-12 comunicate-container">
          <h2>Seu cupom de desconto foi ativado com sucesso!</h2>
          <p class="mb-5">Aproveite para comunicar os consumidores através de algum dos canais.</p>

          <section v-for="channel in channels" :key="channel.name" class="d-flex flex-column align-start mb-2">
            <mf-tooltip top :disabled="isChannelAllowed(channel.name)" max-width="200">
              <template #activator>
                <mf-button
                  icon="arrow_forward"
                  icon-position="right"
                  color="marca-0-l40"
                  :label="channel.label"
                  :disabled="!isChannelAllowed(channel.name)"
                  @click="isChannelAllowed(channel.name) && goTo(channel.route)"
                />
              </template>
              <span>{{ tooltipMessage }}</span>
            </mf-tooltip>
          </section>

          <p class="mt-8 mb-0">Você também pode fazer isso em outro momento.</p>

          <mf-button text class="mt-5" data-cy="backToIndex" label="Voltar para o índice" @click="$router.push({ name: 'cupom-desconto' }).catch(() => {})" />
        </section>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CommunicateByChannel',
  props: {
    benefitId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      channels: [
        { name: 'sms', label: 'Comunicar por SMS', route: 'campanhas-sms-cadastro' },
        { name: 'email', label: 'Comunicar por E-mail', route: 'campanhas-email-cadastro' },
        { name: 'banner', label: 'Comunicar por Banner', route: 'banners-new' },
        { name: 'whatsapp', label: 'Comunicar por Whatsapp', route: 'campanhas-whatsapp-cadastro' },
        { name: 'push', label: 'Comunicar por notificação Push', route: 'campanhas-aplicativo-cadastro' },
      ],
      channelsPermissionsStatus: {},
    }
  },
  computed: {
    tooltipMessage() {
      return 'Você não tem acesso a esse canal. Para mais informações, consulte seu consultor Mercafacil ou o nosso suporte'
    },
  },
  created() {
    this.channelsPermissionsStatus = this.getChannelsPermissionsStatus(this.$permissions, this.$getAllowedModules)
  },
  methods: {
    isChannelAllowed(channelName) {
      return this.channelsPermissionsStatus[channelName] === true
    },
    goTo(routeName) {
      this.$router.push({ name: routeName, params: { benefitId: this.benefitId } })
    },
    getChannelsPermissionsStatus(userPermissionsMethods, plataformModulesMethod) {
      return {
        sms: userPermissionsMethods.havePagePermission('campanhas/sms'),
        whatsapp: userPermissionsMethods.havePagePermission('campanhas/whatsapp') && plataformModulesMethod()['whatsapp'],
        push: userPermissionsMethods.havePagePermission('campanhas/aplicativo') && plataformModulesMethod()['push'],
        email: userPermissionsMethods.havePagePermission('campanhas/email-v2') && plataformModulesMethod()['email_v2'],
        banner: userPermissionsMethods.havePagePermission('mobile/banners') && plataformModulesMethod()['mobile'],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.comunicate-container {
  max-width: 562px;

  h2 {
    font-size: 26px;
    color: $cinza-d10;
    margin-bottom: 24px;
  }

  p {
    font-size: 16px;
    color: $cinza-0;
    line-height: 24px;
  }
}
</style>
